<template>
 <div id="app">
    <router-view />
  </div>
</template>

<script>

import { useHead } from "@vueuse/head";
export default {
  name: "App",
  setup() {
    useHead({
      title: "医疗转诊系统",
      meta: [
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no",
        },
      ],
    });
  },
};
</script>

<style>

html,
body {
  height: 100%; /* 设置 html 和 body 高度为 100% */
  margin: 0; /* 去除默认边距 */
}

</style>
